<template>
    <div class="message-centre-page page">
        <div
            v-if="!phase2_enabled"
            class="card card-body"
            >
            <div>Unauthorized Page</div>
        </div>
        <div v-else class="position-relative">
            <div class="row">
                <div class="col-sm-12">
                    <div class="page-title-box d-block d-sm-flex justify-content-sm-between">
                        <h4 class="page-title" id="page_title">Customer Enquiry</h4>
                    </div>
                </div>
            </div>
            <b-card class="customer-enquiries">
                <div style="min-height: calc(100vh - 282px)">
                    <b-tabs content-class="mt-3" fill card>
                        <b-tab title="Enquiries" active>
                            <customer-enquiries />
                        </b-tab>
                        <b-tab title="Contact Submission">
                            <customer-contact-submission />
                        </b-tab>
                    </b-tabs>
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
import CustomerContactSubmission from '@/components/main/customer-enquiry/ContactSubmission';
import CustomerEnquiries from '@/components/main/customer-enquiry/Enquiries';
import { BTabs, BTab } from 'bootstrap-vue';

const {
  config: { phase2_enabled },
} = window.App.state

export default {
    components: {
        BTabs,
        BTab,
        CustomerContactSubmission,
        CustomerEnquiries
    },
    data() {
        return {
            phase2_enabled,
        }
    }
}
</script>
